import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';
import { requestCacheFn } from '@/utils/requestCache';

// 接口缓存2秒
function requestCache(obj: Recordable) {
  return requestCacheFn(obj, request, 2000);
}

// 设计款列表
export const getDesignList = (data: any, params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/page.ac`,
    method: 'post',
    data,
    params,
  });
};

// 设计款列表汇总
export const getDesignStatistics = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/statistics.ac`,
    method: 'post',
    data,
  });
};

// 新增设计款
export const addDesign = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/add.ac`,
    method: 'post',
    data,
  });
};

// 修改设计款
export const editDesign = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/edit.ac`,
    method: 'post',
    data,
  });
};

// 获取设计款
export const getDesign = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/get.ac`,
    method: 'post',
    params,
  });
};

// 获取设计款(safe会校验查看权限的二级权限)
export const safeGetDesign = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/safeGet.ac`,
    method: 'post',
    params,
  });
};

// 获取设计款
export const getForChoose = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/getForChoose.ac`,
    method: 'post',
    data,
  });
};
// 批量选择设计款
export const batchGetDesignForChoose = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/batchGetForChoose.ac`,
    method: 'post',
    data,
  });
};
// 批量获取设计款详情
export const batchGetDesign = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/batchGet.ac`,
    method: 'post',
    data,
  });
};

// 删除设计款
export const deleteDesign = (data: any) => {
  const { designId, ...rest } = data;
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/delete.ac?designId=${designId}`,
    method: 'post',
    data: rest,
  });
};

// 封样
export const sealedSample = (designId: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/sealedSample.ac?designId=${designId}`,
    method: 'post',
  });
};

// 取消封样
export const sealedSampleCancel = (designId: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/sealedSampleCancel.ac?designId=${designId}`,
    method: 'post',
  });
};

// 转大货-设计款资料
export const convertToGoods = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/convertToGoods.ac`,
    method: 'post',
    params,
  });
};
// 转大货-设计款资料 -- 新接口
export const convertToGoodsV2 = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/v2/convertToGoods.ac`,
    method: 'post',
    data,
  });
};
// 设计款取消转大货
export const cancelConvertToGoods = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/cancelConvertToGoods.ac`,
    method: 'post',
    params,
  });
};

// 更新大货资料-设计款资料
export const syncToGoods = (params: any, noErrorToast?: boolean) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/syncToGoods.ac`,
    method: 'post',
    params,
    noErrorToast,
  });
};

// 转大货-版单资料
export const convertToGoodsByOrder = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/convertToGoods.ac`,
    method: 'post',
    params,
  });
};
// 转大货-版单资料 -- 新接口
export const convertToGoodsByOrderV2 = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/v2/convertToGoods.ac`,
    method: 'post',
    data,
  });
};

// 更新大货资料-版单资料
export const syncToGoodsByOrder = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/syncToGoods.ac`,
    method: 'post',
    params,
  });
};

// 修改设计款状态
export const editDesignState = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/editDesignState.ac`,
    method: 'post',
    data,
  });
};

// 修改设计款季节
export const editDesignSeason = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/editDesignSeason.ac`,
    method: 'post',
    data,
  });
};

// 查询节点模板列表
export const getDesignTemplateList = (data: any, params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/node/template/queryList.ac`,
    method: 'post',
    data,
    params,
  });
};

// 新增版单
export const designOrderAdd = (data: any) => {
  return request({
    method: 'post',
    url: `${BASE_URL.scmServer}/api/admin/design/order/add.ac`,
    data,
  });
};
// 批量新增版单
export const designOrderBatchAdd = (data: any) => {
  return request({
    method: 'post',
    url: `${BASE_URL.scmServer}/api/admin/design/order/batchAdd.ac`,
    data,
  });
};

// 编辑版单
export const designOrderEdit = (data: any) => {
  return request({
    method: 'post',
    url: `${BASE_URL.scmServer}/api/admin/design/order/edit.ac`,
    data,
  });
};

// 判断设计款号是否被占用
export const getDefaultDesignOrderSn = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/getDefaultDesignOrderSn.ac`,
    method: 'post',
    params,
  });
};
// 批量获取版单号
export const batchGetDefaultDesignOrderSn = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/batchGetDefaultDesignOrderSn.ac`,
    method: 'post',
    data,
  });
};

// 分页查询版单列表
export const designOrderQueryList = (
  params: any,
  data?: any,
  hideLoading?: boolean
) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/queryList.ac`,
    method: 'post',
    params,
    data,
    hideLoading,
  });
};

// 查看tab统计
export const queryListExtra = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/queryTabStatistics.ac`,
    method: 'post',
    data,
  });
};
// 查看版单详情
export const getDesignOrder = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/getDesignOrder.ac`,
    method: 'post',
    params,
  });
};

// 获取默认节点模板的接口
export const getDefaultNodeTemplate = () => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/node/template/getDefaultNodeTemplate.ac`,
    method: 'post',
  });
};

// 查询版单节点列表
export const selectDesignNodeList = (params: any, data?: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/selectDesignNodeList.ac`,
    method: 'post',
    params,
    data,
  });
};
// 获取版次列表的接口
export const getDesignOrderSerialList = (params: any, data?: any) => {
  return requestCache({
    url: `${BASE_URL.scmServer}/api/admin/design/order/getDesignOrderSerialList.ac`,
    method: 'post',
    params,
    data,
  });
};

// 撤销
export const designOrderDestory = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/destory.ac`,
    method: 'post',
    params,
  });
};
// 恢复打版
export const designOrderRenew = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/renew.ac`,
    method: 'post',
    params,
  });
};

// 结束打版
export const designOrderFinish = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/finish.ac`,
    method: 'post',
    params,
  });
};
// 检查日志是否可以用于同步
export const snapshotLogCheck = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/snapshotLogCheck.ac`,
    method: 'post',
    data,
  });
};
// 日志详情
export const getSnapshotLog = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/operate/snapshot/log/get.ac`,
    method: 'post',
    data,
  });
};
// 日志列表
export const getSnapshotLogList = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/operate/snapshot/log/queryList.ac`,
    method: 'post',
    data,
  });
};
// 设为最终版
export const designSetFinalVersion = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/setFinalVersion.ac`,
    method: 'post',
    data,
  });
};
// 废版
export const designOrderAbolish = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/abolish.ac`,
    method: 'post',
    data,
  });
};
// 版单汇报进度
export function designNodeReport(data?: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/designNodeReport.ac`,
    method: 'post',
    data,
  });
}
// 查询版单节点汇报进度
export function queryDesignOrderReportList(params: any, data?: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/queryDesignOrderReportList.ac`,
    method: 'post',
    params,
    data,
  });
}
// 获取审版结果列表
export function getDesignNodeReviewResultList(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/getDesignNodeReviewResultList.ac`,
    method: 'post',
    params,
  });
}

// 驳回
export function designNodeReject(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/designNodeReject.ac`,
    method: 'post',
    data,
  });
}

// 指派接口
export function assignLeader(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/assignLeader.ac`,
    method: 'post',
    data,
  });
}

// 修改节点
export function editDesignNodeList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/editDesignNodeList.ac`,
    method: 'post',
    data,
  });
}

// 删除版单节点汇报进度
export function reportDelete(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/reportDelete.ac`,
    method: 'post',
    params,
  });
}
// 交付样衣
export function designHandoverConfirm(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/handover/approvalConfirm.ac`,
    method: 'post',
    data,
  });
}
// 获取样衣交付单详情
export function designHandoverGet(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/handover/get.ac`,
    method: 'post',
    params,
  });
}
// 撤销样衣交付单
export function designHandoverDestroy(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/handover/destroy.ac`,
    method: 'post',
    params,
  });
}

// 获取交付记录列表
export function listByDesignOrder(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/handover/listByDesignOrder.ac`,
    method: 'post',
    params,
  });
}

// 设计款数据进行样衣交付提交
export const getDesignOrderDtListForHandover = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/getDesignOrderDtListForHandover.ac`,
    method: 'post',
    params,
  });
};

// 编辑设计款备注
export function updateDesignOrderRemark(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/updateDesignOrderRemark.ac`,
    method: 'post',
    data,
  });
}

// 设计款物料清单bom锁定/解锁
export function editBomStateByDesign(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/editBomState.ac`,
    method: 'post',
    data,
  });
}

export function editBomFinishByDesign(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/editBomFinish.ac`,
    method: 'post',
    data,
  });
}

// 版单物料清单bom锁定/解锁
export function editBomStateByDesignOrder(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/editBomState.ac`,
    method: 'post',
    data,
  });
}

// 版单物料清单bom完成状态
export function editBomFinishByDesignOrder(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/editBomFinish.ac`,
    method: 'post',
    data,
  });
}
// 批量指派
export function batchAssignLeader(data: Recordable[]) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/batch/assignLeader.ac`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
    data,
  });
}

// 查询所有版单节点名称
export function allDesignNodeNameList() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/allDesignNodeNameList.ac`,
    method: 'post',
    data: {},
  });
}
// 借还单列表（新）
export function borrowListNew(params: Recordable, data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/borrow/list.ac`,
    method: 'post',
    data,
    params,
  });
}

// 提交借还单[返回借还单单号]（新）
export function approvalBorrowConfirmNew(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/borrow/approvalConfirm.ac`,
    method: 'post',
    data,
  });
}

// 撤销借还单（新）
export function destroyBorrowNew(params: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/borrow/destroy.ac`,
    method: 'post',
    params,
  });
}

// 借还单详情（新）
export function getBorrowDetailNew(params: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/borrow/get.ac`,
    method: 'post',
    params,
  });
}

// 提交归还单[返回归还单单号]（新）
export function approvalBackConfirmNew(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/back/approvalConfirm.ac`,
    method: 'post',
    data,
  });
}

// 撤销归还单（新）
export function destroyBackNew(params: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/back/destroy.ac`,
    method: 'post',
    params,
  });
}

// 归还单详情（新）
export function getBackDetailNew(params: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/back/get.ac`,
    method: 'post',
    params,
  });
}

// 归还单列表（新）
export function backListNew(params: Recordable, data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/back/list.ac`,
    method: 'post',
    params,
    data,
  });
}

// 领取样衣
export function pickDesign(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/user/record/pick.ac`,
    method: 'post',
    data,
  });
}

// 修改样衣借还人
export function changeOwner(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/user/record/changeOwner.ac`,
    method: 'post',
    data,
  });
}

// 样衣借还人记录
export function getPickDesignRecord(data: Recordable, params: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/design/user/record/list.ac`,
    method: 'post',
    data,
    params,
  });
}

// 多款导入
export function importMultiDesigns(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/import.ac`,
    method: 'post',
    data,
    params,
  });
}
// 多导入修改
export function importEditDesigns(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/importEdit.ac`,
    method: 'post',
    data,
    params,
  });
}

// 多款导出
export function getImportEditDesignsExportData(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/getImportEditExportData.ac`,
    method: 'post',
    data,
  });
}

// 更新物料单品齐料状态
export function updateIsCompleteBySkuIds(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/updateIsCompleteBySkuIds.ac`,
    method: 'post',
    data,
  });
}

// 获取列表的发料进度表
export const getIssueMaterialList = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/listMaterialInfo.ac`,
    method: 'post',
    params,
  });
};

// 查看转大货审核日志
export function queryConvertGoodsLogList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/convertToGoods/audit/record/page.ac`,
    method: 'post',
    data,
  });
}

// 转大货提交审核(未大货->待审核)
export function submitConvertGoodsAudit(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/approvalProcess/workProcessEdit/audit/submit.ac`,
    method: 'post',
    data,
  });
}

// 转大货撤销审核
export function cancelConvertGoodsAudit(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/convertToGoods/waitAudit/destroy.ac`,
    method: 'post',
    data,
  });
}

// 转大货审核(待审核->已大货)
export function comfirmConvertGoodsAudit(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/convertToGoods/audit.ac`,
    method: 'post',
    data,
  });
}

export function queryDesignIeOperateRecord(data: any, query: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/pageIeOperateRecord.ac`,
    method: 'post',
    data,
    params: query,
  });
}

export function getDesignIeOperateRecordInfo(query: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/getIeOperateRecordInfo.ac?recordId=${query.recordId}`,
    method: 'post',
  });
}

// IE核价报表
export function getIePriceReportList(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/ie/queryList.ac`,
    method: 'post',
    data,
    params,
  });
}

// 检查设计款单品是否已经被使用
export function checkSkuIsUsed(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/checkSkuIsUsed.ac`,
    method: 'post',
    data,
  });
}
// 节点审核日志
export function auditFlowOperateLog(data: Recordable, params: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/order/pageOperateLog.ac`,
    method: 'post',
    data,
    params,
  });
}
// 检查设计款单品条码是否重复
export function checkoutDesignSkuBarcode(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/designSku/checkoutSkuBarcode.ac`,
    method: 'post',
    data,
  });
}
// 检查设计款单品编码是否重复
export function checkoutDesignSkuCode(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/designSku/checkoutSkuCode.ac`,
    method: 'post',
    data,
  });
}
// 初始化设计款单品编码
export function initDesignSkuCode(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/designSku/initSkuCode.ac`,
    method: 'post',
    data,
  });
}
// 自动生成设计款单品编码
export function generateDesignSkuCode(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/designSku/generateSkuCode.ac`,
    method: 'post',
    data,
  });
}
